import { FunctionComponent, h } from 'preact'
import { EndingField as EndingFieldType } from 'scripts/type'
import { usdDelayShow } from 'scripts/hooks'
import { htmlEncodeByRegExp } from 'scripts/utils'

import styles from './index.scss'

const endingImgSrc = 'https://static.howxm.com/stars-crop.gif'

type Props = {
  field: EndingFieldType
}

const EndingField: FunctionComponent<Props> = ({ field }) => {
  const { visible } = usdDelayShow(350)
  const content = htmlEncodeByRegExp(field?.content || '感谢您的反馈')
  return (
    <div className={styles.ending} style={visible ? { opacity: 1 } : {}}>
      <div className={styles.img}>
        <img src={visible ? endingImgSrc : ''} alt={'success gif'} />
      </div>
      <div className={styles.content} dangerouslySetInnerHTML={{ __html: content }} />
    </div>
  )
}

export default EndingField
